// legacy IE function
// expression( <any-value> )
export default function() {
    return this.createSingleNodeList(
        this.Raw(null, false)
    );
}
